import React from 'react';
import { Card, Text, mergeClassNames } from '@clockout-dev/design-elements';
import styles from './styles/summary-card.module.scss';

function SummaryCard({ title, subtitle, className, children }) {
    return (
        <Card className={mergeClassNames([styles.card, className])}>
            <div className={styles.header}>
                <Text as="span" className={styles.title}>{title}</Text>
                {subtitle ? <Text as="span" className={styles.subtitle}>{subtitle}</Text> : null}
            </div>
            {children}
        </Card>
    );
}

export default SummaryCard;
